import React from 'react';

import PTypes from '../ContentPTypesQB';

const LicenseTypeGroups = props => <PTypes {...props} content="license_type_groups" />;

export default LicenseTypeGroups;
